import React, { useEffect } from 'react'

import { useHistory, useParams } from 'react-router-dom'

import ConfirmAccount from '../../../../../presentation/pages/common/confirm-account'

import { makeConfirmAccount } from '../../../../usecases/user-confirm-account/remote-user-confirm-account-factory'

import { RoutesEnum } from '../../../../../presentation/enums'

type ParamsProps = {
  email: string
}
const MakeConfirmAccount = () => {
  document.title = 'BuscarMédicos - Confirmar conta'

  const history = useHistory()
  const params = useParams<ParamsProps>()
  useEffect(() => {
    async function confirmAccount() {
      try {
        await makeConfirmAccount().postConfirmAccount({
          email: params.email,
        })
        setTimeout(() => {
          history.push(RoutesEnum.SIGNIN)
        }, 4000)
      } catch (err) {
        console.error(err)
      }
    }

    confirmAccount()
  }, [])

  return <ConfirmAccount />
}

export default MakeConfirmAccount
